import Head from 'next/head'
import Image from 'next/image'
import styles from '../styles/Home.module.css'
import Header from "../src/local/Header"
import ErrorBoundary from "../src/local/ErrorBoundary"
import MainBox from "../src/local/MainBox"
import picture from "../public/image.webp"
import varos from "../public/varos.jpg"
import android from "../public/android.png"
import ios from "../public/apple.png"
import app from "../public/app2.jpg"
import onkormanyzat from "../public/onkormanyzat.jpg"
import { useTheme, useMediaQuery } from '@mui/material';
import theme from "./api/theme"
import Link from 'next/link'

export default function Home() {
	const theme = useTheme();
	const largeScreen = useMediaQuery(theme.breakpoints.up('md'));

	return (
		<ErrorBoundary>
			<div className={styles.main}>
				<Header />
				<div className={styles.grid}>
					<Link href="https://play.google.com/store/apps/details?id=hu.holmiapp" passHref>
						<Image
							src={android}
							alt="android"
						/>
					</Link>
					<Link href="https://apps.apple.com/hu/app/id1570622313#?platform=iphone" passHref>
						<Image src={ios} alt="ios" />
					</Link>
					<Image src={picture} alt="Kép" className={styles.grid_img} /*style={{
						marginTop: "3rem", marginBottom: "3rem", minHeight: "300px"
					}}*//>
					{/*<div>
						<img className={styles.center_img} src="/holmiappcolor.svg" height="64px" />
					</div>*/}
					<div className={styles.title}>Alkalmazásunk elérhető android és ios rendszeren.</div>
					<h1><span>&quot;Találd meg, ami téged érdekel&quot;</span></h1>
				</div>
			</div>
			<div className={styles.grey}>
				<div className={styles.flex} style={{ maxWidth: largeScreen ? "960px" : undefined }}>
					<MainBox
						title="BEMUTATÓ" img_url="/app2.jpg" picture={app}
						body="A helyi önkormányzatokkal együttműködve, összegyűjtöttük a téged érdeklő információkat.
						Hírek, események, információk, minden egy helyen."
						largeScreen={largeScreen}
						btn_url="/Bemutato" btn_title="BÖVEBBEN"
					/>
					<MainBox
						title="TELEPÜLÉSEK" img_url="/varos.jpg" picture={varos}
						body="Jelenleg 5 településen érhető el szolgáltatásunk. Az információt szolgáltató
						 települések számát folyamatosan bővítjük"
						largeScreen={largeScreen}
						btn_url="/Telepulesek" btn_title="TOVÁBB"
					/>
					<MainBox
						title="ÖNKORMÁNYZAT" img_url="/onkormanyzat.jpg" picture={onkormanyzat}
						body="A HolmiApp-ot használva, az önkormányzatoknak lehetősége nyílik a lakossággal
						történő kommunikáció fejlesztésére, modernizálására."
						//A HolmiApp szolgáltatás minimális ráfordítással dinamikusan skálázódik."
						largeScreen={largeScreen}
						btn_url="/Onkormanyzat" btn_title="MEGNÉZEM"
					/>
				</div>
			</div>
		</ErrorBoundary>
	)
}
